/* ============================================================
   cfg-reveal · fade-in al hacer scroll
   Sylaris · usa IntersectionObserver
   ============================================================ */
(function () {
  'use strict';

  const SEL = '[data-cfg-reveal]';

  function init() {
    const els = document.querySelectorAll(SEL);
    if (!els.length) return;

    /* Fallback: si no hay IO, revelar todo */
    if (typeof IntersectionObserver === 'undefined') {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }

    /* Respeta motion reducido del usuario */
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      els.forEach(el => el.classList.add('is-revealed'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = parseInt(el.dataset.cfgRevealDelay || '0', 10);
        if (delay > 0) {
          setTimeout(() => el.classList.add('is-revealed'), delay);
        } else {
          el.classList.add('is-revealed');
        }
        io.unobserve(el);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    });

    els.forEach(el => io.observe(el));
  }

  /* Re-escanear si se inyectan elementos nuevos (ej. configurador renderiza mount) */
  function rescan() {
    const els = document.querySelectorAll(SEL + ':not(.is-revealed)');
    if (!els.length) return;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expongo rescan por si el configurador inyecta cards/steps tras render */
  window.cfgRevealRescan = rescan;
})();
